import React, { useContext, useRef } from "react";
import anime from "animejs/lib/anime.es.js";
import Context from "../../context";
import { map } from "../../utils.js";

export const addTypoAnimation = (tl, context) => {
  tl.add({
    //animate stop in
    targets: ".stopAnimation svg",
    scale: [0, 1],
    duration: 800,
    easing: "easeInOutQuint",
  })
	.add({
		targets: ".stopAnimation span",
		fontSize: function (el, i, l) {
			return [0, map(i, 0, l - 1, 10, 3) + "em"];
		},
		duration: 800,
		delay: anime.stagger(100),
		easing: "easeInOutQuint",
		begin: (anim) => {
			context.onTriggerGridAnimation("stop");
		},
	})
	tl.add({
    //move stop up
    targets: ".stopAnimation",
    translateY: '-100%',
		scale: '0.5',
    duration: 800,
    easing: "easeInOutQuint",
  }, "+=100")
	.add({
		//animate start in
		targets: ".startAnimation svg",
		scale: [0, 1],
		duration: 800,
		easing: "easeInOutQuint",
	}, "-=500")
	.add({
		targets: ".startAnimation span",
		fontSize: function (el, i, l) {
			return [0, map(i, 0, l - 1, 3, 10) + "em"];
		},
		duration: 800,
		delay: anime.stagger(100),
		easing: "easeInOutQuint",
		begin: function (anim) {
			context.onTriggerGridAnimation("start");
		},
	})
	tl.add({
    //move start up
    targets: ".startAnimation",
    translateY: '-50%',
		scale: '0.5',
    duration: 800,
    easing: "easeInOutQuint",
  }, "+=100")
	tl.add({
    //move stop up
    targets: ".stopAnimation",
    translateY: '-100%',
		scale: '0.25',
    duration: 800,
    easing: "easeInOutQuint",
  }, '-=750')
	tl.add({
    //move weiter down
    targets: ".weiterAnimation",
    translateY: '50%',
		//scale: '0.75',
    duration: 0,
		easing: "easeInOutQuint"
  })
	.add({
		//animate weiter in
		targets: ".weiterAnimation svg",
		scale: [0, 1],
		duration: 800,
		easing: "easeInOutQuint",
	}, '-=800')
	.add({
		targets: ".weiterAnimation span",
		fontSize: function (el, i, l) {
			let shift = map(i, 0, l - 1, -100, 100);
			let value = map(Math.abs(shift), 0, 100, 10, 3);
			return [0, value + "em"];
		},
		duration: 800,
		delay: anime.stagger(100),
		easing: "easeInOutQuint",
		begin: function (anim) {
			context.onTriggerGridAnimation("continue");
		},
	})
	.add(
		{
			//animate stop out
			targets: [".stopAnimation span", ".startAnimation span", ".weiterAnimation span"],
			fontSize: 0,
			duration: 150,
			delay: anime.stagger(50),
			easing: "easeInOutQuint",
		},
		"+=500"
	)
	.add(
		{
			targets: [".stopAnimation svg", ".startAnimation svg", ".weiterAnimation svg" ],
			scale: 0,
			duration: 300,
			delay: anime.stagger(450),
			easing: "easeInOutQuint",
		},
		"-=1400"
	)
};

const Animation = () => {
  const typoAnimationWrapper = useRef(0);

  return (
    <div ref={typoAnimationWrapper} className="typoAnimationWrapper">
      <div className="typoAnimation startAnimation">
        <svg
          className="typoAnimation-icon"
          width="100px"
          height="100px"
          viewBox="0 0 100 100"
        >
          <polygon
            id="Fill-27-Copy"
            fill="#00FCAC"
            points="19.9487179 99.6948533 84.0512821 49.6948533 19.9487179 -0.305146717"
          ></polygon>
        </svg>
        <span>#</span>
        <span>s</span>
        <span>t</span>
        <span>a</span>
        <span>r</span>
        <span>t</span>
      </div>
      <div className="typoAnimation stopAnimation">
        <svg
          className="typoAnimation-icon"
          width="100px"
          height="100px"
          viewBox="0 0 100 100"
        >
          <rect
            id="Rectangle"
            fill="#FF0000"
            x="10"
            y="10"
            width="80"
            height="80"
          ></rect>
        </svg>
        <span>#</span>
        <span>s</span>
        <span>t</span>
        <span>o</span>
        <span>p</span>
      </div>
      <div className="typoAnimation weiterAnimation">
        <svg
          className="typoAnimation-icon"
          width="100px"
          height="100px"
          viewBox="0 0 100 100"
          version="1.1"
        >
          <polygon
            fill="#9454FF"
            points="0 101 49.8266667 50.5002742 0 -7.27595761e-12"
          ></polygon>
          <polygon
            fill="#9454FF"
            points="49.8266667 101 99.6533333 50.5002742 49.8266667 -7.27595761e-12"
          ></polygon>
        </svg>
        <span>#</span>
        <span>w</span>
        <span>e</span>
        <span>i</span>
        <span>t</span>
        <span>e</span>
        <span>r</span>
      </div>
    </div>
  );
};

export default Animation;
